import Card from "@/components/UI/Card/Card";
import Button from "@/components/UI/Button/Button";
import { AlertIcon } from "@/components/Icons/AlertIcon";
import styles from "./SavedPrescriptionCard.module.css";
import { PrescriptionOrigin } from "@/types/prescription.types";
import { OnlineIcon, StoreIcon } from "../Icons";
import { useTranslation } from "@/i18n";
import { formatDate } from "@/utils";

interface SavedPrescriptionCardProps {
  prescriptionOrigin: PrescriptionOrigin;
  date: string;
  prescriptionNameText: string;
  prescriptionName: string;
  uploadedOnText?: string;
  expiredOnText?: string;
  ctaText?: string;
  warningText?: string;
  disabled?: boolean;
  className?: string;
  expiredDate: string | null;
  isLoading?: boolean;
  onCtaClick?: () => void;
  onClick?: () => void;
}

export default function SavedPrescriptionCard({
  prescriptionOrigin,
  date,
  prescriptionNameText,
  prescriptionName,
  uploadedOnText,
  expiredOnText,
  ctaText,
  warningText,
  disabled = false,
  className,
  onCtaClick,
  onClick,
  expiredDate,
  isLoading = true,
}: SavedPrescriptionCardProps) {
  const dateText = uploadedOnText || expiredOnText;

  if (expiredDate) {
    let expireDate: Date | string = new Date(expiredDate || "");
    expireDate = expireDate.toISOString();
  }

  const { t } = useTranslation();

  console.log("SavedPrescriptionCard props:", {
    disabled,
  });

  return (
    <Card
      className={`${styles.savedPrescriptionCard} ${disabled ? styles.disabled : ""} ${className || ""}`.trim()}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <div className={styles.locationRow}>
        {prescriptionOrigin === PrescriptionOrigin.STORE ? (
          <StoreIcon size={16} color="disabled" />
        ) : (
          <OnlineIcon size={16} color="disabled" />
        )}
        <span className={styles.locationText}>
          {t(
            `myAccount.prescriptions.prescriptionOrigin.${prescriptionOrigin}`,
          )}
        </span>
      </div>

      {dateText && (
        <div className={styles.dateText}>
          {dateText}{" "}
          <span className={styles.dateBold}>
            {expiredOnText && expiredDate
              ? formatDate(expiredDate)
              : formatDate(date)}
          </span>
        </div>
      )}

      <div className={styles.prescriptionInfo}>
        <span className={styles.prescriptionLabel}>{prescriptionNameText}</span>
        <span className={styles.prescriptionValue}>{prescriptionName}</span>
      </div>

      {ctaText && onCtaClick && (
        <Button
          variant="link"
          onClick={(e) => {
            e.stopPropagation();
            onCtaClick();
          }}
          className={styles.ctaLink}
        >
          {ctaText}
        </Button>
      )}

      {warningText && (
        <div className={styles.warningBox}>
          <AlertIcon size={20} color="text" />
          <span className={styles.warningText}>{warningText}</span>
        </div>
      )}
      {isLoading && <span className={styles.loader} />}
    </Card>
  );
}
